// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {BiArrowBack, BiPrinter} from "react-icons/bi";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Loading from "../../../components/loading/Loading";
import {
    addJobRequestTransaksiSelector,
    getJobRequestDetailUser,
    getMJS,
    updatePremit,
} from "../../hrd/transaksi/job-request/AddjobRequestTransaksiSlice";

import {Colors} from "../../../assets/Colors";
import {maxPageGlobal} from "../../../assets/config";

function isRequired(value) {
    let status = false;
    if (value !== null) {
        if (typeof value === "number") {
            if (value !== -1) {
                status = true;
            }
        }

    }
    return status;
}

function useForm(initialState = {}, validations = [], onSubmit = () => {
}) {
    const {isValid: initialIsValid, errors: initialErrors} = validate(
        validations,
        initialState
    );
    const [changed, setChanged] = useState(false);
    const [values, setValues] = useState(initialState);
    const [errors, setErrors] = useState(initialErrors);
    const [isValid, setValid] = useState(initialIsValid);
    const [touched, setTouched] = useState({});

    const changeHandler = (event) => {
        const newValues = {...values, [event.target.name]: event.target.value};
        const {isValid, errors} = validate(validations, newValues);
        setChanged(true);
        setValues(newValues);
        setValid(isValid);
        setErrors(errors);
        setTouched({...touched, [event.target.name]: true});
    };

    const changeHandlerActivity = (data) => {
        const newValues = {...values, Activity: data};
        const {isValid, errors} = validate(validations, newValues);
        setChanged(true);
        setValues(newValues);
        setValid(isValid);
        setErrors(errors);
    };

    const editHandler = (initValues) => {
        const newValues = {
            ...values,
            WSBNo: initValues.WSBNo,
            Klien: initValues.Klien,
            PermitToWork: initValues.PermitToWork,
            ShippingManifest: initValues.ShippingManifest,
            QuatationNo: initValues.QuatationNo,
            SPKNo: initValues.SPKNo,
            KlienID: initValues.KlienID,
            Priority: initValues.Priority,
            StatusKet: initValues.StatusKet,
            Activity: initValues.Activity,
            Status: initValues.Status,
            MJS: initValues.MJS
        };
        setValues(newValues);
    };

    const clearHandler = () => {
        setValues(initialState);
    };

    const submitHandler = (event) => {
        event.preventDefault();
        onSubmit(values);
    };
    return {
        values,
        changeHandler,
        editHandler,
        clearHandler,
        isValid,
        errors,
        touched,
        submitHandler,
        changeHandlerActivity,
    };
}

function validate(validations, values) {
    const errors = validations
        .map((validation) => validation(values))
        .filter((validation) => typeof validation === "object");
    return {
        isValid: errors.length === 0,
        errors: errors.reduce((errors, error) => ({...errors, ...error}), {}),
    };
}

const ReportMJS = ({}) => {
    const jobRequest = useSelector(addJobRequestTransaksiSelector);
    let initialState = {
        PermitToWork: "",
        Status: "",
        QuatationNo: "",
        SPKNo: "",
        Priority: "",
        KlienID: "",
        StatusKet: "",
        Activity: [],
    };

    const param = useLocation();

    const validations = [
        ({QuatationNo}) =>
            isRequired(QuatationNo) || {QuatationNo: "Nomor Quatation wajib diisi"},
        ({SPKNo}) => isRequired(SPKNo) || {SPKNo: "Nomor SPK wajib diisi"},
        ({Priority}) =>
            isRequired(Priority) || {Priority: "Priority wajib diisi"},
        ({KlienID}) => isRequired(KlienID) || {KlienID: "ID Klien wajib diisi"},
    ];

    const {
        values,
        errors,
        touched,
        changeHandler,
        editHandler,
        changeHandlerActivity,
    } = useForm(initialState, validations);
    const [buttonTouched, setButtonTouched] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [Tanggal, setTanggal] = useState("");
    const [TanggalIncoming, setTanggalIncoming] = useState("");

    const [isValidTanggal, setIsValidTanggal] = useState(true);
    const [isValidTanggalIncoming, setIsValidTanggalIncoming] = useState(true);

    const [dateChanged, setDateChanged] = useState(false);
    const [checkListChanged, setCheckListChanged] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [Quatation, setQuatation] = useState([]);

    const [insertFetch, setInsertFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});
    const [permitError, setpermitError] = useState(false);
    const [total, setTotal] = useState(0);

    const [jobRequestList, setjobRequestList] = useState([]);

    const [checkedState, setCheckedState] = useState(
        new Array(jobRequestList.length).fill(false)
    );

    const [checkedStateDetail, setCheckedStateDetail] = useState(
        new Array(jobRequestList.length).fill(false)
    );

    const handleOnChange = (position) => {
        const updatedCheckedState = checkedState.map((item, index) =>
            index === position ? !item : item
        );

        setCheckedState(updatedCheckedState);
    };

    const inputArray = [
        {
            type: "text",
            id: 1,
            value: "",
        },
    ];

    function handleInsertJR() {
        if (values.PermitToWork === "") {
            setpermitError(true)
        } else {
            let sendArray = {
                PermitToWork: values.PermitToWork,
                JRID: jobRequest.dataDetail.JRID,
            };


            dispatch(updatePremit(sendArray));
        }

    }

    useEffect(() => {
        dispatch(getJobRequestDetailUser({JRID: param.state.JRID}));
        dispatch(getMJS({JRID: param.state.JRID}));

    }, []);

    useEffect(() => {
    });
    let user = JSON.parse(localStorage.getItem("user"));

    const getDataGeneralFromURL = (url) =>
        new Promise((resolve, reject) => {
            url = url.replaceAll("/", "-");
            setTimeout(() => {
                fetch(process.env.REACT_APP_API_URL+"pdfInvoice?id=" + url, {
                    method: "GET", // or 'PUT'
                    headers: {
                        Accept: "*/*",
                        Authorization: "Bearer " + user.Token,
                    },
                })
                    .then((response) => response.blob())
                    .then((data) => {
                        const file = window.URL.createObjectURL(data);
                        window.open(file);
                    });
            });
        }, 2000);

    useEffect(() => {
        if (jobRequest.isGetDetailSuccess && !firstLoading && jobRequest.isGetMJS) {
            if (values.Activity.length === 0) {
                changeHandlerActivity(jobRequest.dataDetail.Activity);
            }

            const initValues = {
                PermitToWork: jobRequest.dataDetail.PermitToWork,
                Status: jobRequest.dataDetail.Status,
                ShippingManifest: jobRequest.dataDetail.ShippingManifest,
                IncomingDate: jobRequest.dataDetail.IncomingDate,
                QuatationNo: jobRequest.dataDetail.QuatationNo,
                WSBNo: jobRequest.dataDetail.WSBNo,
                Klien: jobRequest.dataDetail.Klien,
                SPKNo: jobRequest.dataDetail.SPKNo,
                Priority: jobRequest.dataDetail.Priority,
                KlienID: jobRequest.dataDetail.KlienID,
                StatusKet: jobRequest.dataDetail.StatusKet,
                Activity: jobRequest.dataDetail.Activity,
                MJS: jobRequest.mjs
            };
            let subtotal = 0
            jobRequest.mjs.map((data) => {
                subtotal += parseInt(data.Total)
            })
            setTotal(subtotal)

            editHandler(initValues);
            setTanggal(
                new Date(
                    new Date(jobRequest?.dataDetail && jobRequest?.dataDetail.Date)
                )
            );
            setTanggalIncoming(
                new Date(
                    new Date(
                        jobRequest?.dataDetail && jobRequest?.dataDetail.IncomingDate
                    )
                )
            );
            setFirstLoading(true);
        }
        if (jobRequest.isUpdateSuccess) {
            dispatch(getJobRequestDetailUser({JRID: param.state.JRID}));
            setFirstLoading(true);
            navigate("/operasional-permit");
        }
    });

    if (!firstLoading) {
        return <Loading/>;
    } else {
        return (
            <>
                <div className="md:ml-64">
                    <div
                        style={{background: Colors.white}}
                        className="pt-14 pb-16 px-3 md:px-8 h-auto"
                    >
                        <div className="container mx-auto max-w-full">
                            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                        </div>
                    </div>
                    <div className="px-3 md:px-8 h-auto -mt-32">
                        <div className="flex w-full justify-end p-4 flex-col sm:flex-row pt-4">
                            <button
                                onClick={() => navigate("/operasional-monitoring-finance")}
                                className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                            >
                                <BiArrowBack className="text-xl text-gray-800 pr-2"/>
                                Kembali
                            </button>
                            <button
                                onClick={() => getDataGeneralFromURL(param.state.JRID)}
                                className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                            >
                                <BiPrinter className="text-xl text-gray-800 mr-2"/>

                                Cetak
                            </button>
                        </div>
                        <div className="flex flex-row">
                            <div className="px-4 py-4 flex-1">
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            No JR
                                        </label>
                                        <div className="inline-block relative w-full">
                                            <input
                                                disabled
                                                value={param.state.JRID}
                                                onChange={changeHandler}
                                                name="JRID"
                                                className={
                                                    (touched.QuatationNo || buttonTouched) &&
                                                    errors.QuatationNo
                                                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                }
                                                type="text"
                                            />
                                        </div>
                                        {(touched.QuatationNo || buttonTouched) &&
                                            errors.QuatationNo && (
                                                <p className="text-red-500 text-xs italic">
                                                    {errors.QuatationNo}
                                                </p>
                                            )}
                                    </div>
                                </div>
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Nomor Quatation
                                        </label>
                                        <div className="inline-block relative w-full">
                                            <input
                                                disabled
                                                value={values.QuatationNo}
                                                onChange={changeHandler}
                                                name="QuatationNo"
                                                className={
                                                    (touched.QuatationNo || buttonTouched) &&
                                                    errors.QuatationNo
                                                        ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                        : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                }
                                                type="text"
                                            />
                                        </div>
                                        {(touched.QuatationNo || buttonTouched) &&
                                            errors.QuatationNo && (
                                                <p className="text-red-500 text-xs italic">
                                                    {errors.QuatationNo}
                                                </p>
                                            )}
                                    </div>
                                </div>

                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Priority
                                        </label>
                                        <div className="inline-block relative w-full  ">
                                            <input
                                                disabled
                                                value={values.Priority}
                                                name="Priority"
                                                className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-wrap -mx-3 mb-6">

                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-light-gray-700 text-xs font-bold mb-2">
                                            Nomor WBS
                                        </label>
                                        <input
                                            value={values.WSBNo}
                                            onChange={changeHandler}
                                            name="WSBNo"
                                            className={
                                                (touched.SPKNo || buttonTouched) && errors.WSBNo
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            type="text"
                                        />
                                        {(touched.WSBNo || buttonTouched) && errors.WSBNo && (
                                            <p className="text-red-500 text-xs italic">
                                                {errors.WSBNo}
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-light-gray-700 text-xs font-bold mb-2">
                                            Nomor SPK
                                        </label>
                                        <input
                                            value={values.SPKNo}
                                            onChange={changeHandler}
                                            name="SPKNo"
                                            className={
                                                (touched.SPKNo || buttonTouched) && errors.SPKNo
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            type="text"
                                        />
                                        {(touched.SPKNo || buttonTouched) && errors.SPKNo && (
                                            <p className="text-red-500 text-xs italic">
                                                {errors.SPKNo}
                                            </p>
                                        )}
                                    </div>

                                </div>

                            </div>
                            <div className="p-4 flex-1">
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Client
                                        </label>
                                        <input
                                            disabled
                                            value={values.Klien}
                                            onChange={changeHandler}
                                            name="Klien"
                                            className={
                                                (touched.KlienID || buttonTouched) && errors.KlienID
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            type="text"
                                        />
                                        {(touched.KlienID || buttonTouched) && errors.KlienID && (
                                            <p className="text-red-500 text-xs italic">
                                                {errors.KlienID}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className="flex flex-wrap -mx-3">
                                    <div className="w-full px-3 mb-6">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Tanggal
                                        </label>
                                        <DatePicker
                                            className={
                                                !isValidTanggal
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            disabled={values.Priority !== "P3"}
                                            selected={Tanggal}
                                            onChange={(date) => {
                                                setTanggal(date);
                                                setIsValidTanggal(true);
                                                if (showModalEdit) {
                                                    setDateChanged(true);
                                                }
                                            }}
                                        />
                                        {!isValidTanggal && (
                                            <p className="text-red-500 text-xs italic">
                                                Tanggal pengajuan wajib diisi
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Shipping Manifest
                                        </label>
                                        <input
                                            disabled
                                            value={values.ShippingManifest}
                                            onChange={changeHandler}
                                            name="ShippingManifest"
                                            className={
                                                (touched.ShippingManifest || buttonTouched) &&
                                                errors.ShippingManifest
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            type="text"
                                        />
                                        {(touched.ShippingManifest || buttonTouched) &&
                                            errors.ShippingManifest && (
                                                <p className="text-red-500 text-xs italic">
                                                    {errors.ShippingManifest}
                                                </p>
                                            )}
                                    </div>
                                </div>
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Incoming Date / Time
                                        </label>
                                        <DatePicker
                                            disabled
                                            className={
                                                !isValidTanggalIncoming
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            selected={TanggalIncoming}
                                            onChange={(date) => {
                                                setTanggalIncoming(date);
                                                setIsValidTanggalIncoming(true);
                                            }}
                                        />
                                        {!isValidTanggalIncoming && (
                                            <p className="text-red-500 text-xs italic">
                                                Tanggal Incoming wajib diisi
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full px-3 mb-6 md:mb-0">
                                        <label
                                            className={permitError ? "block uppercase tracking-wide text-red-700 text-xs font-bold mb-2" : "block uppercase tracking-wide text-green-700 text-xs font-bold mb-2"}>
                                            Permit to Work No *
                                        </label>
                                        <input
                                            value={values.PermitToWork}
                                            onChange={changeHandler}
                                            name="PermitToWork"
                                            className={
                                                permitError
                                                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                            }
                                            type="text"
                                        />
                                        {permitError &&
                                            <p className="text-red-500 text-xs italic">Required</p>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-4">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                MJS
                            </label>
                            <table
                                className="table-auto w-full bg-transparent border-collapse ">
                                <thead>
                                <tr>
                                    <th

                                        style={{color: Colors.primary}}
                                        className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                    >
                                        Jenis Aktivity
                                    </th>
                                    <th

                                        style={{color: Colors.primary}}
                                        className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                    >
                                        Quantity
                                    </th>
                                    <th

                                        style={{color: Colors.primary}}
                                        className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                    >
                                        Oum
                                    </th>
                                    <th

                                        style={{color: Colors.primary}}
                                        className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                    >
                                        Harga Satuan
                                    </th>
                                    <th

                                        style={{color: Colors.primary}}
                                        className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                    >
                                        Total
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                {values.MJS &&
                                    values.MJS.map((detail, detailID) => {
                                        const totals = parseInt(detail.Total)
                                        const satuan = parseInt(detail.HargaSatuan)
                                        return (
                                            <tr key={detailID}>
                                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    {detail.JenisActivity}
                                                </th>
                                                <th className="border-b border-gray-200 text-right align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    {detail.Quatity}
                                                </th>
                                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    {detail.Oum}
                                                </th>
                                                <th className="border-b border-gray-200 text-right align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    {satuan.toLocaleString(undefined, {maximumFractionDigits: 2})}
                                                </th>
                                                <th className="border-b border-gray-200 text-right align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                                    {totals.toLocaleString(undefined, {maximumFractionDigits: 2})}
                                                </th>
                                            </tr>
                                        )
                                    })
                                }
                                <tr key={"Total"}>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    </th>
                                    <th className="border-b border-gray-200 text-right align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    </th>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    </th>
                                    <th className="border-b border-gray-200 text-right align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                        Total
                                    </th>
                                    <th className="border-b border-gray-200 text-right align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                        {total.toLocaleString(undefined, {maximumFractionDigits: 2})}

                                    </th>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default ReportMJS;
